module.exports = __webpack_public_path__ + "static/media/work-9.6781356c.png";